import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../../common/planTheme.css";
import "../Report/ReportView.css";
import DayPlan from "./ViewDayPlan";
import { AiOutlineArrowLeft } from "react-icons/ai";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "react-loader-spinner";
import {DecryptED} from "../../DecryptJS/Decrypt"
import { getWeeklyPlanConfig } from "../weeklyPlanConfig";
import { FcDownload } from "react-icons/fc";
import { handleDownloadExcel } from "../ExportToExcel";
const AdminReportView = () => {
  const { sid, userid, reportid } = useParams();
  const cfg = getWeeklyPlanConfig(DecryptED(sid));
  const [weeklyData, setWeeklyData] = useState([]);
  const [reportData, setReportData] = useState({ month: "", lession_name: "", subject: "", div_name: "" });
  const [apiloader, setapiLoader] = useState(true);
  const [updating, setUpdating] = useState(false);

  const [exportData, setExportData] = useState({
    headers: [
      "Days", "Subject", "sub topic", "Class_Division", "Lesson Name", "Period",
      cfg.teacherActivityLabel ? "Teacher's Activity" : "imp. notes",
      "class activity",
      ...(cfg.learningOutcomes ? ["Learning Outcomes"] : []),
      cfg.assignmentLabel ? "Assignment" : "HomeWork",
      ...(cfg.hideAccomplished ? [] : ["accomplished"])
    ],
    body: []
  }
  )

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const getReportById = async () => {
    setapiLoader(true);
    try {
      const data = {
        sid: DecryptED(sid),
        id: DecryptED(reportid),
        userId: DecryptED(userid)
      }
      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_URL}/api/admin/weeklyPlan/reportById`,
        data,
        headers: {
          Authorization: "#$laksdfnlknoea#$@$%^&%$",
        },
      });
      const result = response.data || [];
      if (!result.length) {
        Swal.fire("Error", "Weekly plan not found", "error");
        return;
      }
      setWeeklyData(result);
      setReportData({ month: result[0].month, lession_name: result[0].lession_name, subject: result[0].subject, div_name: result[0].div_name });
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Could not load the weekly plan. Please try again.", "error");
    } finally {
      setapiLoader(false);
    }
  }
  useEffect(() => {
    getReportById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const updateReport = async(e) =>{
    e.preventDefault();

    if (!reportData.month || !reportData.lession_name) {
      const missing = [];
      if (!reportData.month) missing.push("Month");
      if (!reportData.lession_name) missing.push("Lesson Name");
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Please fill the required fields: ${missing.join(", ")}`,
      });
      return;
    }
    const data = {
      fun_name: "updateWeeklyLessonplanData",
      staff_id: weeklyData[0].staff_id,
      sid: DecryptED(sid),
      class_id: weeklyData[0].class_id,
      subject_id: weeklyData[0].subject_id,
      month: reportData.month,
      lession_name: reportData.lession_name,
      lesson_id: weeklyData[0].lesson_id,
      days: weeklyData,
      userId: DecryptED(userid)
    };
    setUpdating(true);
    try {
      const response = await axios.post(
        "https://topschool.prisms.in/rest/index.php/staff_list.json",
        data
      );
      if (response.data && response.data.success !== false) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Plan has been updated successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire("Error", (response.data && response.data.message) || "Could not update the plan", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Could not update the plan. Please try again.", "error");
    } finally {
      setUpdating(false);
    }
  }

  useEffect(() => {
    
    const myArray = weeklyData.map(item => {
      return {
        Days: item.days,
        subject: item.subject,
        top_sub_top: item.top_sub_top,
        div_name: item.div_name,
        Lesson_Name: item.lession_name,
        Period: item.no_of_period,
        imp_notes: item.imp_note,
        class_activity: item.cls_activity,
        ...(cfg.learningOutcomes ? { learning_outcome: item.learning_outcome } : {}),
        HomeWork: item.homework,
        ...(cfg.hideAccomplished ? {} : { accomplished: item.accomplished })
      }
    });
    setExportData((prev) => ({...prev, body: myArray}))
  }, [weeklyData])

  return (
    <div className="lp-scope weeklyreportview-page">
      {
        apiloader ? (
          <div className="TMLoader">
            <Loader type="ThreeDots" color="#bd2f5e" height={80} width={80} />
          </div>
        ) :
          <>
            <Link
              to={`/admin/weeklyPlan/${sid}/${userid}`}
              aria-label="Back to weekly plan reports"
              style={{
                display: "flex",
                width: "fit-content",
                alignItems: "center",
                gap: "6px",
                color: "#1565c0",
                fontWeight: 600,
                textDecoration: "none",
                margin: "0 auto 16px",
                maxWidth: "900px",
              }}
            >
              <AiOutlineArrowLeft size={20} />
              Back
            </Link>
            <p className="lp-page-title" style={{ textAlign: "center" }}>Weekly Lesson Plan</p>
            <form className="form lp-card" onSubmit={updateReport}>
              <div className="user-details">
                <div className="weeklyreportview-titleRow">
                  <p className="lp-section-title" style={{ margin: 0 }}>Lesson Details</p>
                  <button
                    type="button"
                    className="weeklyreportview-downloadBtn"
                    aria-label="Download as Excel"
                    onClick={()=>handleDownloadExcel(exportData.headers, exportData.body)}
                  >
                    <FcDownload size={22} />
                  </button>
                </div>
                <div className="form-details">
                  <div className="form-inputs">
                    <label className="lp-field-label" htmlFor="classDisplay">Class</label>
                    <input className="lp-input" id="classDisplay" value={reportData.div_name || ""} readOnly aria-readonly="true" />
                  </div>
                  <div className="form-inputs">
                    <label className="lp-field-label" htmlFor="month">
                      Month<span className="lp-required">*</span>
                    </label>
                    <input
                      className="lp-input"
                      onChange={(e) => setReportData({ ...reportData, month: e.target.value })}
                      name="month"
                      id="month"
                      type="month"
                      value={reportData.month || ""}
                    />
                  </div>
                </div>
                <div className="form-details">
                  <div className="form-inputs">
                    <label className="lp-field-label" htmlFor="subjectDisplay">Subject</label>
                    <input className="lp-input" id="subjectDisplay" value={reportData.subject || ""} readOnly aria-readonly="true" />
                  </div>
                  <div className="form-inputs">
                    <label className="lp-field-label" htmlFor="lessonName">
                      Lesson Name<span className="lp-required">*</span>
                    </label>
                    <input
                      className="lp-input"
                      value={reportData.lession_name || ""}
                      onChange={(e) => setReportData({ ...reportData, lession_name: e.target.value })}
                      id="lessonName"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <p className="lp-section-title" style={{ marginTop: "24px" }}>Day-by-Day Plan</p>
              <div className="Accordion">
                {weeklyData.length > 0 ? days.map((day, idx) => {
                  return (
                    <DayPlan
                      days={day}
                      key={idx}
                      index ={idx}
                      weeklyData={weeklyData[idx] ? weeklyData[idx] : ""}
                      setWeeklyData={setWeeklyData}
                      cfg={cfg}
                    />
                  );
                }) : "No data available"}
              </div>
              <div className="btn-div">
                <button type="submit" className="lp-btn lp-btn-primary" disabled={updating}>
                  {updating ? "Updating…" : "Update Data"}
                </button>
              </div>
            </form>
          </>
      }
    </div>
  );
};

export default AdminReportView;

